/**
 * Pilumo catalog-grid card interactivity.
 *
 * The rich product cards used on Catalogo, Toelettatura, Bagno & Asciugatura
 * and Novità (snippets/pilumo-grid-*.liquid) render every variant's data as
 * JSON on the card's <product-form-component data-variant-matrix="...">.
 * Selecting a color swatch or size pill only toggled the (visually hidden)
 * radio input — nothing read that selection, so the card kept pointing at
 * whatever variant Liquid picked on render (selected_or_first_available_variant).
 * This file makes that selection actually do something: it swaps the price,
 * sale/sold-out badges, image and the variant id the Add to Cart form submits,
 * moves the visual "selected" ring (.is-selected) to the swatch/pill the
 * shopper actually picked, and updates the card's image/title links so
 * clicking through lands on the exact variant chosen, not just the
 * product's default.
 */
(function () {
  if (window.__pilumoCatGridBound) return;
  window.__pilumoCatGridBound = true;

  function getVariants(card) {
    var form = card.querySelector('product-form-component[data-variant-matrix]');
    if (!form) return null;
    try {
      return { form: form, variants: JSON.parse(form.getAttribute('data-variant-matrix')) };
    } catch (e) {
      return null;
    }
  }

  function findMatch(variants, selections) {
    return variants.find(function (v) {
      return Object.keys(selections).every(function (pos) {
        var key = 'option' + pos;
        return v[key] === selections[pos];
      });
    });
  }

  function updateCard(card) {
    var data = getVariants(card);
    if (!data) return;

    var selections = {};
    card.querySelectorAll('[data-pilumo-option]:checked').forEach(function (input) {
      selections[input.getAttribute('data-option-position')] = input.value;
    });
    if (!Object.keys(selections).length) return;

    var match = findMatch(data.variants, selections);
    if (!match) return;

    // Variant id the Add to Cart form will submit.
    var variantIdInput = data.form.querySelector('input[name="id"]');
    if (variantIdInput) variantIdInput.value = match.id;

    // Price + compare-at price.
    var priceNow = card.querySelector('.pilumo-catcard__price-now');
    if (priceNow && match.price) priceNow.textContent = match.price;
    var priceCompare = card.querySelector('.pilumo-catcard__price-compare');
    if (priceCompare) {
      if (match.compare_at_price) {
        priceCompare.textContent = match.compare_at_price;
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }

    // Sale / sold-out badges.
    var saleBadge = card.querySelector('.pilumo-catcard__badge:not(.pilumo-catcard__badge--soldout)');
    if (saleBadge) saleBadge.hidden = !match.compare_at_price;
    var soldBadge = card.querySelector('.pilumo-catcard__badge--soldout');
    if (soldBadge) soldBadge.hidden = !!match.available;

    // Card image.
    if (match.image) {
      var img = card.querySelector('.pilumo-catcard__media img');
      if (img) {
        img.src = match.image;
        img.removeAttribute('srcset');
      }
    }

    // Add to cart button state + label.
    var addBtn = card.querySelector('.pilumo-catcard__add');
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Aggiungi al Carrello' : 'Esaurito';
    }

    // Deep-link the image + title to this exact variant so clicking through
    // opens the product page already on the one the shopper selected here.
    ['.pilumo-catcard__media', '.pilumo-catcard__title'].forEach(function (selector) {
      var link = card.querySelector(selector);
      if (!link) return;
      var base = link.getAttribute('data-pilumo-base-href');
      if (!base) {
        base = link.getAttribute('href').split('?')[0];
        link.setAttribute('data-pilumo-base-href', base);
      }
      link.setAttribute('href', base + '?variant=' + match.id);
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest ? event.target.closest('[data-pilumo-option]') : null;
    if (!input) return;
    var card = input.closest('.pilumo-catcard');
    if (!card) return;

    // Move the visual "selected" ring to the swatch/pill just picked. The
    // native radio input's checked state already switched (that's what
    // drives the variant matching below) but nothing else in this file
    // moved the .is-selected class that draws the ring, so it used to stay
    // stuck on whichever swatch Liquid marked selected at page load.
    var group = input.closest('[data-pilumo-option-group]');
    if (group) {
      Array.prototype.slice.call(group.querySelectorAll('label')).forEach(function (label) {
        label.classList.remove('is-selected');
      });
      var ownLabel = input.closest('label');
      if (ownLabel) ownLabel.classList.add('is-selected');
    }

    updateCard(card);
  });
})();
